import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material-next/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from "prop-types";
import { Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import BlurryDialog from '../../../widget/BlurryDialog';
import FormSegment from '../../../widget/FormSegment';
import { buildFilterForm } from '../../../utils/FilterUtils';

const KanbanAdvancedFilterDialog = (props) => {
  const { t } = useTranslation();

  const descriptionElementRef = useRef(null);

  useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  const setActiveFilter = () => {
    props.handleSubmit();
  }

  const addAnswerToSegment = (segmentIndex, type, answers) => {
    var newForm = JSON.parse(JSON.stringify(props.filterForm));
    if (type === 'radial') {
      newForm[segmentIndex].radial.push(answers[0]);
    } else {
      newForm[segmentIndex].freeText = answers;
    }

    props.setFilterForm(newForm);
  }

  const removeAnswerFromSegment = (segmentIndex, answer) => {
    var newForm = JSON.parse(JSON.stringify(props.filterForm));
    newForm[segmentIndex].radial = newForm[segmentIndex].radial.filter(e => e !== answer);
    props.setFilterForm(newForm);
  }

  const doesSegmentContainAnswer = (segmentIndex, answer) => {
    return props.filterForm[segmentIndex].radial.includes(answer);
  }

  const getAutocompleteValues = (segmentIndex) => {
    return props.filterForm[segmentIndex].freeText;
  }

  const clearFilter = () => {
    const newForm = buildFilterForm( Object.keys(props.filterForm).length);
    props.setFilterForm(newForm);
  }

  return (

    <BlurryDialog
      open={props.open}
      onClose={props.handleClose}
      maxWidth='xl'
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="color color-medium-purple">
        <b>
          {t("kanban.advancedFilter")}
        </b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent style={{ maxHeight: '600px' }}>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <Grid container spacing={2}>
          {props.formBuilder.segments.map((segment, index) => {
            return (
            <>
              <Grid id={("gridSegment-" + index)}
                    key={("gridSegment-" + index)}
                    item xs={3}>
                  <FormSegment
                    id={("formSegment" + index)}
                    key={("formSegment-" + index)}
                    segmentIndex={index}
                    segment={segment}
                    addAnswerToSegment={addAnswerToSegment}
                    removeAnswerFromSegment={removeAnswerFromSegment}
                    doesSegmentContainAnswer={doesSegmentContainAnswer}
                    getAutocompleteValues={getAutocompleteValues}
                  />
              
              </Grid>
            </>)
          })}
          </Grid>

        </DialogContentText>
      </DialogContent>
      <DialogContent>
        <DialogActions>
        <Button
            variant="filled"
            disableElevation
            className="bg bg-medium-pink"
            size="small"
            style={{ borderRadius: '10px', marginRight: '5px' }}
            onClick={() => {
              clearFilter();
            }}
          >
            {t("clearFilter")}
          </Button>
          <Button
            variant="filled"
            disableElevation
            className="bg bg-medium-purple"
            type="submit"
            size="small"
            style={{ borderRadius: '10px' }}
            onClick={() => {
              setActiveFilter();
            }}
          >
            {t("saveFilter")}
          </Button>
        </DialogActions>
      </DialogContent>
    </BlurryDialog>

  );
}

KanbanAdvancedFilterDialog.propTypes = {
  filterForm: PropTypes.object,
  setFilterForm: PropTypes.func,
  formBuilder: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default KanbanAdvancedFilterDialog;